import { Component, OnInit } from '@angular/core';
import { ProjectService } from 'src/app/services/project.service';
import { Observable } from 'rxjs';
import { AngularFirestoreCollectionGroup, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  projects: AngularFirestoreCollectionGroup<any>[];
  banner: AngularFirestoreDocument<any>;
  redes: AngularFirestoreCollectionGroup<any>[];
  certificados: AngularFirestoreCollectionGroup<any>[];
  showButtonScroll: boolean = false;

  constructor(public projectService: ProjectService, private route: Router) { }

  ngOnInit() {
    this.projectService.getProjects().valueChanges().subscribe(
      res => this.projects = res
    );
    this.projectService.getBanner().valueChanges().subscribe(
      res => this.banner = res
    )
    this.projectService.getRedes().valueChanges().subscribe(
      res => this.redes = res
    )
    this.projectService.getCertificados().valueChanges().subscribe(
      res => this.certificados = res
    )
  }
}
